<template>
  <div class="statistical-report-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入用户ID" size="small" clearable class="param-input" v-model="params.uid">
      </el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getUserTody()">搜索</el-button>
    </div>
    <!--表格数据-->
    <el-table
      max-height="650"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
      <el-table-column prop="uid" label="视频博主id" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="博主姓名" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="videoDeduction" label="视频扣量" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.videoDeduction }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="videoDeductionCount" label="已扣量视频数" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.videoDeductionCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="videoDeductionPayCount" label="视频售卖总次数" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.videoDeductionPayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="beforeDeduction" label="扣量前总售卖（金币）" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.beforeDeduction }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="afterDeduction" label="扣量后总售卖（金币）" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.afterDeduction }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deductionCount" label="被扣量视频总数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.deductionCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nonDedcutionCount" label="未扣量视频总数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.nonDedcutionCount }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      // 时间数据绑定字段
      time: "",
      tableData: [],
      gross: 0,//时间段内所有视频金币总收入
      grossBool: false,
      // 表格数据加载动画
      loading: false,
      // 用户今日统计列表请求参数
      params: {
        // pageNumber: 1,
        // pageSize: 10,
        startTime: null,
        endTime: null,
        uid: undefined,
      },
    };
  },
  methods: {
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || null;
        this.params.endTime = changeTime(time[1]) || null;
      } else {
        this.params.startTime = null;
        this.params.endTime = null;
      }
      this.getUserTody();
    },
    // 请求用户今日统计列表数据
    getUserTody() {
      this.loading = true;
      API.getVideoKlGoldStat({ ...this.params })
        .then((res) => {
          this.loading = false;
          // this.grossBool = false;
          this.tableData = [];
          if (res.code === 200 && res.data) {
            this.tableData.push(res.data);
            // this.gross = res.data.gross;
            // if (res.data.list.length > 0) {
            //   this.grossBool = true;
            // }
          } else {
            this.tableData = [];
            // this.gross = 0;
            // this.grossBool = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
